// extracted by mini-css-extract-plugin
export default {"connected":"tGBOC","connected-link":"RsHCV"};